import * as Shared from "../Shared";
import angular = require("angular");
export interface ISetBannerColorScope extends ng.IScope {
  setBannerColorCtrl: SetBannerColorDirective;
}

export class SetBannerColorDirective implements ng.IDirective {
  public restrict = "A";

  public scope = {};

  public link = (
    $rootScope: ng.IRootScopeService,
    $elem: ng.IAugmentedJQuery
  ) => {
    if (window.location.hostname.indexOf("localhost") >= 0) {
        $elem.attr("style", "background-color: black; border-color: black");
    } else if (window.location.hostname.indexOf("con2.igssolarpower.com") >= 0) {
        $elem.attr("style", "background-color: #ff9900; border-color: #ff9900");
    } else if (window.location.hostname.indexOf("con3.igssolarpower.com") >= 0) {
        $elem.attr("style", "background-color: #ff9999; border-color: #ff9999");
    } else if (window.location.hostname.indexOf("dev.igssolarpower.com") >= 0) {
      $elem.attr("style", "background-color: red; border-color: red");
    } else if (window.location.hostname.indexOf("int.igssolarpower.com") >= 0) {
      $elem.attr("style", "background-color: orange; border-color: orange");
    } else if (window.location.hostname.indexOf("qa.igssolarpower.com") >= 0) {
      $elem.attr("style", "background-color: green; border-color: green");
    } else if (window.location.hostname.indexOf("trn.igssolarpower.com") >= 0) {
        $elem.attr("style", "background-color: firebrick; border-color: firebrick"); 
    }
  };
}

var app = angular.module("set.Banner.Color", []);
app.directive(
  "setBannerColor",
  Shared.Framework.DirectiveHelpers.create(SetBannerColorDirective)
);
